import React from 'react';
import { useTranslation } from 'react-i18next';
import CheckIcon from '../Icons/CheckIcon';

const IncludeInstructions: React.FC = () => {
  const { t } = useTranslation(['includeTeam']);

  return (
    <>
      <span className="instruction-title">{t('instructions_to_send')}</span>
      <div className="instructions-wrapper">
        <div className="instruction-box">
          <CheckIcon />
          <p>{t('verify')}</p>
        </div>
        <div className="instruction-box">
          <CheckIcon />
          <p>
            <strong>{t('attention')}</strong> {t('fill')}
          </p>
        </div>
        <div className="instruction-box">
          <CheckIcon />
          <p>
            {t('case_cpf')} <strong>{t('replaced')}</strong>
          </p>
        </div>
        <div className="instruction-box">
          <CheckIcon />
          <p>
            {t('include_up_to')} <strong>{t('500')}</strong> {t('per_import')}
          </p>
        </div>
        <div className="instruction-box">
          <CheckIcon />
          <p>
            {t('save_in_format')} <strong>.csv</strong>
          </p>
        </div>
      </div>
    </>
  );
};

export default IncludeInstructions;
